import SearchQueries from './SearchQueries';

export default SearchQueries;
